import { Stack } from '@mui/material';
import type { InventoryResource, Snapshot } from '@repo/api-gw-sdk';

import { MultiAccordionsItem } from '@/components/accordion/multiAccordionsItem';
import type { BackupVault } from '@/data/vaults/backupVault';

import type { MutateSnapshots } from './eonSnapshotsTab';
import { SnapshotDetailsBody, type VolumeOrDisk } from './snapshotDetailsBody';
import { SnapshotDetailsHeader } from './snapshotDetailsHeader';
import { SnapshotOptionMenu } from './snapshotOptionMenu';
import type { RestoreActionType } from './vmSnapshotRow';

export const SnapshotDetails = ({
  testid,
  snap,
  vault,
  isSelected,
  onSelect,
  onRestore,
  resource,
  onConvertSnapshot,
  snapshotSelection: snapshotSelection,
  mutateSnapshots,
}: {
  testid?: string;
  snap: Snapshot;
  vault: BackupVault | undefined;
  isSelected: boolean;
  onSelect: () => void;
  onRestore: (volumes: VolumeOrDisk[], actionType: RestoreActionType) => void;
  onConvertSnapshot?: (
    volumes: VolumeOrDisk[],
    actionType: RestoreActionType
  ) => void;
  resource: InventoryResource;
  snapshotSelection: boolean;
  mutateSnapshots: MutateSnapshots;
}) => {
  return (
    <MultiAccordionsItem
      testid={testid}
      sx={{ paddingRight: '40px' }}
      isMulti={snapshotSelection}
      isSelected={isSelected}
      onSelect={onSelect}
      summary={
        <Stack
          flex={1}
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <SnapshotDetailsHeader
            snap={snap}
            vault={vault}
            isSelected={isSelected}
            onSelect={onSelect}
            snapshotSelection={false}
          />
          <SnapshotOptionMenu
            snap={snap}
            mutateSnapshots={mutateSnapshots}
            resource={resource}
          />
        </Stack>
      }
      Details={
        <SnapshotDetailsBody
          mutateSnapshots={mutateSnapshots}
          snapshot={snap}
          vault={vault}
          onRestore={onRestore}
          resource={resource}
          onConvertSnapshot={onConvertSnapshot}
        />
      }
    />
  );
};
